// LICENSE_CODE ZON
'use strict';
/*jslint node:true, es6:true, react:true*/

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useCallback, useContext } from 'react';
import cn from 'classnames';
import _debounce from 'lodash.debounce';
import { Trans as T, useTranslation } from 'react-i18next';
import { capitalize } from '/util/string.js';
import etask from '/util/etask.js';
import { fetch } from '/util/fetch.js';
import { Settings_context } from '../settings_ctx';
import Info from '../../../toolip/pub/img/icons/info.svg';
import styles from './pass_meter.module.less';
const default_messages = {
  'weak': 'Not quite',
  'medium': 'Almost there',
  'good': 'Just a bit more',
  'perfect': 'Perfect!'
};
export const Pass_meter = props => {
  useTranslation();
  const pass = props.pass,
        email = props.email,
        _props$messages = props.messages,
        messages = _props$messages === void 0 ? default_messages : _props$messages;

  const _useState = useState('empty'),
        _useState2 = _slicedToArray(_useState, 2),
        strength = _useState2[0],
        set_strength = _useState2[1];

  const msg = messages[strength] || capitalize(strength);
  const check_pass = useCallback(_debounce(_pass => etask(function* () {
    if (!_pass) return void set_strength('empty');

    try {
      const res = yield fetch('/users/check_pass', {
        method: 'POST',
        body: {
          pass: _pass,
          email
        }
      });
      set_strength(res);
    } catch (e) {}
  }), 500), []);
  useEffect(() => {
    check_pass(pass);
  }, [pass]);
  const cls = cn('pass_meter', styles.wrapper);
  return pass && /*#__PURE__*/React.createElement("div", {
    className: cls
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.meter
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.filler, styles[strength])
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.msg
  }, /*#__PURE__*/React.createElement(T, null, msg)))));
};
export const Pass_meter_2023 = props => {
  useTranslation();

  const _useContext = useContext(Settings_context),
        theme = _useContext.theme;

  const pass = props.pass,
        email = props.email,
        bars = props.bars,
        _props$messages2 = props.messages,
        messages = _props$messages2 === void 0 ? default_messages : _props$messages2,
        _props$show_messages = props.show_messages,
        show_messages = _props$show_messages === void 0 ? true : _props$show_messages,
        _props$show_requireme = props.show_requirements,
        show_requirements = _props$show_requireme === void 0 ? true : _props$show_requireme;

  const _useState3 = useState('empty'),
        _useState4 = _slicedToArray(_useState3, 2),
        strength = _useState4[0],
        set_strength = _useState4[1];

  const msg = messages[strength] || capitalize(strength);
  const check_pass = useCallback(_debounce((_pass, _e) => etask(function* () {
    if (!_pass) return void set_strength('empty');

    try {
      const res = yield fetch('/users/check_pass', {
        method: 'POST',
        body: {
          pass: _pass,
          email: _e
        }
      });
      set_strength(res);
    } catch (e) {}
  }), 500), []);
  useEffect(() => {
    check_pass(pass, email);
  }, [pass, email]);
  const cls = cn('pass_meter', styles.wrapper, styles.wrapper_2023, styles[strength], !pass && styles.empty);
  return /*#__PURE__*/React.createElement("div", {
    className: cls
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.meter_2023
  }, bars ? /*#__PURE__*/React.createElement("div", {
    className: styles.bars,
    "data-role": "bars"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.bar, styles.bar1)
  }), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.bar, styles.bar2)
  }), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.bar, styles.bar3)
  }), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.bar, styles.bar4)
  })) : /*#__PURE__*/React.createElement("div", {
    className: styles.filler
  }), strength != 'empty' && show_messages ? /*#__PURE__*/React.createElement("p", {
    className: theme.p5,
    "data-role": "strength"
  }, "Password strength: ", /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement(T, null, msg))) : /*#__PURE__*/React.createElement("p", {
    className: theme.p5
  }, "\xA0"), show_requirements && (props.requirements || /*#__PURE__*/React.createElement("div", {
    className: styles.info_meter
  }, /*#__PURE__*/React.createElement(Info, {
    width: "20"
  }), /*#__PURE__*/React.createElement("p", {
    className: theme.p5
  }, "At least 8 characters, a combination of upper and lower-case letters, numbers and special characters.")))));
};